"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubHeader = void 0;
const react_1 = __importStar(require("react"));
const buttons_1 = require("../../buttons");
const dialogs_1 = require("../../modals/dialogs");
const __1 = require("..");
const SubHeader_styles_1 = require("./SubHeader.styles");
const SubHeader = ({ title, label, children, showPrimaryButton, description, onClick, certification, menu, }) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement(SubHeader_styles_1.Wrapper, null,
        menu && (react_1.default.createElement(SubHeader_styles_1.TitleWrapper, null,
            react_1.default.createElement(SubHeader_styles_1.TitleWithoutMenu, null, title),
            react_1.default.createElement(SubHeader_styles_1.DialogWrapper, null,
                react_1.default.createElement(dialogs_1.Dialog, { title: menu.title, open: open, setOpen: setOpen, noScrollLock: true, closeFromOverlay: false, onCloseClick: () => setOpen(false) },
                    react_1.default.createElement(__1.SwitchMenu, Object.assign({ isPopup: true, open: open, setOpen: setOpen }, menu)))))),
        react_1.default.createElement(SubHeader_styles_1.RoundButtonWrapper, null,
            certification && (react_1.default.createElement(SubHeader_styles_1.ImageWrapper, null,
                react_1.default.createElement("a", { href: certification.certificationUrl, title: certification.certificationAlternativeText, target: "_blank", rel: "noreferrer nofollow noopener" },
                    react_1.default.createElement("img", { src: certification.certificationSource, alt: certification.certificationAlternativeText })))),
            showPrimaryButton && react_1.default.createElement(buttons_1.Button, { buttonType: "outlined", label: label, onClick: onClick }),
            menu && menu.showProductMenu && (react_1.default.createElement(buttons_1.Button, { buttonType: "outlined", label: menu.productMenuLabel, onClick: () => setOpen(!open) }))),
        react_1.default.createElement(SubHeader_styles_1.ChildrenWrapper, null, children),
        description && (react_1.default.createElement(SubHeader_styles_1.DescriptionWrapper, null,
            react_1.default.createElement(SubHeader_styles_1.Description, null, description)))));
};
exports.SubHeader = SubHeader;
//# sourceMappingURL=SubHeader.js.map